var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.brandLogo)?_c('ImgView',{staticClass:"w-max",attrs:{"src":_vm.brandLogo,"alt":_vm.brand}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }